import { API_NAME, REDUX_STORE } from '@funnels/constants';
import { Expenses, ExpensesActionTypes, ExpensesReducerState, SharedActionTypes } from '@funnels/types';

const initialState: ExpensesReducerState = {
  data: [],
  error: null,
  loading: 0,
};

export default function expenseReducer(
  state: ExpensesReducerState = initialState,
  action: ExpensesActionTypes | SharedActionTypes
): ExpensesReducerState {
  switch (action.type) {
    case REDUX_STORE.SHARED_ACTION_TYPES.CLEAR_DATA:
      return {
        ...state,
        data: [],
      };
    case REDUX_STORE.SHARED_ACTION_TYPES.CLEAR_ERROR:
    case REDUX_STORE.EXPENSES.ACTION_TYPES.CLEAR_EXPENSES_ERROR:
      return {
        ...state,
        error: null,
      };
    case REDUX_STORE.EXPENSES.ACTION_TYPES.CREATE_EXPENSES:
      return {
        ...state,
        data: [...state.data, action.expenses],
        loading: state.loading + 1,
      };
    case REDUX_STORE.EXPENSES.ACTION_TYPES.CREATE_EXPENSES_SUCCESS:
      return {
        ...state,
        data: state.data.map((expenses) =>
          expenses.clientId === action.clientId ? { ...expenses, id: action.id } : expenses
        ),
        loading: state.loading - 1,
      };
    case REDUX_STORE.EXPENSES.ACTION_TYPES.DELETE_EXPENSES:
      return {
        ...state,
        data: state.data.filter((expenses) => expenses.clientId !== action.clientId),
        loading: state.loading + 1,
      };
    case REDUX_STORE.EXPENSES.ACTION_TYPES.DELETE_EXPENSES_SUCCESS:
      return {
        ...state,
        loading: state.loading - 1,
      };
    case REDUX_STORE.EXPENSES.ACTION_TYPES.FETCH_EXPENSES:
      return {
        ...state,
        data: [],
        loading: state.loading + 1,
      };
    case REDUX_STORE.EXPENSES.ACTION_TYPES.FETCH_EXPENSES_SUCCESS:
      return {
        ...state,
        data: action.expenses.map(
          (expenses) =>
            ({
              ...expenses,
              clientId: expenses.applicantId,
            } as Expenses)
        ),
        loading: state.loading - 1,
      };
    case REDUX_STORE.EXPENSES.ACTION_TYPES.SET_EXPENSES_ERROR:
      // TODO: FUNNEL-1606 - use same pattern in employment reducer, setting error message in same action as fail/abort
      return {
        ...state,
        error: {
          name: API_NAME.EXPENSES,
          message: action.message,
        },
      };
    case REDUX_STORE.EXPENSES.ACTION_TYPES.UPDATE_EXPENSES:
      return {
        ...state,
        data: [
          ...state.data.map((expenses) =>
            expenses.clientId === action.expenses.clientId
              ? { ...expenses, expenses: action.expenses.expenses }
              : expenses
          ),
        ],
        loading: state.loading + 1,
      };
    case REDUX_STORE.EXPENSES.ACTION_TYPES.UPDATE_EXPENSES_SUCCESS:
      return {
        ...state,
        loading: state.loading - 1,
      };
    case REDUX_STORE.EXPENSES.ACTION_TYPES.CREATE_EXPENSES_FAIL:
    case REDUX_STORE.EXPENSES.ACTION_TYPES.DELETE_EXPENSES_FAIL:
    case REDUX_STORE.EXPENSES.ACTION_TYPES.FETCH_EXPENSES_FAIL:
    case REDUX_STORE.EXPENSES.ACTION_TYPES.UPDATE_EXPENSES_FAIL:
    case REDUX_STORE.EXPENSES.ACTION_TYPES.UPDATE_EXPENSES_ABORT:
      return {
        ...state,
        loading: state.loading - 1,
      };
    default:
      return state;
  }
}
